export const nonNumberChars = /[^-\d.]/g;
